export default {
    init() {
        this.templateSelect();
        this.checkAllImportedToggle();
        this.checkImportedToggle();
        this.selectToInput();
        this.importedListPaginationInput();
        this.addColAction();
        this.deleteColAction();
        this.turnOnLoader();
    },

    turnOnLoader(){
        document.getElementById('import-excel-form').addEventListener("submit", function(){
            let loader = $('.loader-holder');
            loader.show();
        });
    },

    templateSelect() {
        $('select.select-template').select2();
    },

    checkAllImportedToggle() {
        $('.check-all').on('change', function () {
            let lotsListItem = $('.imported-file-table--item');

            if ($(this).is(':checked')) {
                lotsListItem.each(function (i, val) {
                    $(val).find('.imported-file-checkbox').first().prop('checked', true);
                    $(val).addClass("row-checked");
                });
            } else {
                lotsListItem.each(function (i, val) {
                    $(val).find('.imported-file-checkbox').first().prop('checked', false);
                    $(val).removeClass("row-checked");
                });
            }
        });
    },

    selectToInput() {
        var original_value = '';
        var new_value = '';
        var original_select_value = '';

        $('.select-item.sub-item').each( function(){
            let selectForInput = $(this).find('select.select-template');
            $(this).append('<input type="hidden" name="' + selectForInput.attr('name') + '" value="' + selectForInput.val() + '" />');
        });

        $('.imported-file-table--select select').each( function () {
            let value = $(this).val();//id
            let col = $(this).closest('th').data("column");
            // $('.imported-file-table--selected [data-column="'+col+'"]').html(value);
            $.ajax({
                url: '/manage/import/check-for-options-ajax',
                data: {
                    "field_id": value,
                },
                success: function(response) {
                    if(response){
                        $("td[data-column*='"+col+"'] select").each(function() {
                            var currentValue = String($(this).val()).trim()
                                .replace(/[\s-]+/g, '_')
                                .toLowerCase();
                            var cellName = $(this).attr('name');
                            var selectString =
                                '<select class="value-input-select" name="'+cellName+'">'
                                +
                                response
                                +
                                '</select>'

                            $(this).parent().html(selectString);


                            var optionByTitle = $("select[name*='"+cellName+"'] option[value='"+currentValue+"']");
                            if(optionByTitle.length > 0){
                                optionByTitle.attr('selected','selected');
                            }
                            else{
                                $("select[name*='"+cellName+"']").addClass('red');
                                var currentAsOption = '<option selected="selected" value="">'+currentValue+'</option>';
                                $("select[name*='"+cellName+"']").prepend(currentAsOption);

                            }
                        });
                        $("td[data-column*='"+col+"'] input").each(function() {
                            var currentValue = String($(this).val()).trim()
                                .replace(/[\s-]+/g, '_')
                                .toLowerCase();
                            var cellName = $(this).attr('name');
                            var selectString = 
                                '<select class="value-input-select" name="'+cellName+'">'
                                + 
                                response
                                +
                                '</select>'
                            ;
                            $(this).parent().html(selectString);
    
            
                            var optionByTitle = $("select[name*='"+cellName+"'] option[value='"+currentValue+"']");
                            if(optionByTitle.length > 0){
                                optionByTitle.attr('selected','selected');
                            }
                            else{
                                $("select[name*='"+cellName+"']").addClass('red');
                                var currentAsOption = '<option selected="selected" value="'+currentValue+'">'+currentValue+'</option>';
                                $("select[name*='"+cellName+"']").prepend(currentAsOption);
    
                            }
                        });
                        
                    }
                }
            });
        });

		$('body').on('focusin', '.value-input', function() {
			original_value = $(this).val();
		});

		$('body').on('focusout', '.value-input', function() {
            new_value = $(this).val();
            if(original_value !== new_value){
                if (confirm('Do you wan\'t to replace all "'+original_value+'" items in this column with "'+new_value+'"?')) {
					var column = $(this).parent().attr('data-column');
					$("td[data-column*='"+column+"'] input").each(function() {
					    if($( this ).val() == original_value){
                            $( this ).val(new_value);
                        }
					});
                }
            }
        });

        $('body').on('focusin', '.value-input-select', function() {
            var optionIds = [];
            $(this).parent().parent().find('option:selected').each(function(index,val) {
                if(typeof $(this).attr('optionid') !== 'undefined'){
                    optionIds.push($(this).attr('optionid'));
                    //console.log($(this).attr('optionid'));
                }
            });
            $(this).find('option').each(function(opt) {
               
                 if(typeof $(this).attr('related') !== 'undefined'){
                    var related_id = $(this).attr('related');
                    if(optionIds.includes(related_id) ){
                        $(this).show();
                    }
                    else{
                        $(this).hide();
                    }
                 }
            });
            original_select_value = $(this).val();
        });

		$('body').on('change', '.value-input-select', function() {
            var original_select_text = $(this).find("[value='']").html();
            var new_select_value = $(this).val();
            $( this ).removeClass( "red" );
            if(original_select_value !== new_select_value){
                if (confirm('Do you wan\'t to replace all "'+original_select_value+'" items in this column with "'+new_select_value+'"?')) {
                    
					var column = $(this).parent().attr('data-column');
					$("td[data-column*='"+column+"'] select").each(function() {
					    if($( this ).val() == original_select_value){
                            $( this ).val(new_select_value);
                            $( this ).removeClass( "red" );
                        }
					});

                }
            }
            
        }); 

        $('body').on('change', '.imported-file-table--select select', function () {
            let value = $(this).val();//id
            let col = $(this).closest('th').data("column");
            // $('.imported-file-table--selected [data-column="'+col+'"]').html(value);
            $.ajax({
                url: '/manage/import/check-for-options-ajax',
                data: {
                    "field_id": value,
                },
                success: function(response) {
                    if(response){
                        $("td[data-column*='"+col+"'] select").each(function() {
                            var currentValue = String($(this).val()).trim()
                                .replace(/[\s-]+/g, '_')
                                .toLowerCase();
                            var cellName = $(this).attr('name');
                            var selectString = 
                                '<select class="value-input-select" name="'+cellName+'">'
                                + 
                                response
                                +
                                '</select>'
                            ;
                            $(this).parent().html(selectString);
    
           
                            var optionByTitle = $("select[name*='"+cellName+"'] option[value*='"+currentValue+"']");
                            if(optionByTitle.length > 0){
                                optionByTitle.attr('selected','selected');
                            }
                            else{
                                $("select[name*='"+cellName+"']").addClass('red');
                                var currentAsOption = '<option selected="selected" value="">'+currentValue+'</option>';
                                $("select[name*='"+cellName+"']").prepend(currentAsOption);
    
                            }
                        });
                        $("td[data-column*='"+col+"'] input").each(function() {
                            var currentValue = String($(this).val()).trim()
                                .replace(/[\s-]+/g, '_')
                                .toLowerCase();
                            var cellName = $(this).attr('name');
                            var selectString = 
                                '<select class="value-input-select" name="'+cellName+'">'
                                + 
                                response
                                +
                                '</select>'
                            ;
                            $(this).parent().html(selectString);
    
           
                            var optionByTitle = $("select[name*='"+cellName+"'] option[value='"+currentValue+"']");
                            if(optionByTitle.length > 0){
                                optionByTitle.attr('selected','selected');
                            }
                            else{
                                $("select[name*='"+cellName+"']").addClass('red');
                                var currentAsOption = '<option selected="selected" value="'+currentValue+'">'+currentValue+'</option>';
                                $("select[name*='"+cellName+"']").prepend(currentAsOption);
    
                            }
                        });
                        
                    }
                }
            });
        });


    },

    checkImportedToggle() {
        $(document).on("change", ".imported-file-checkbox", function () {
            $(this).parent().parent().parent().parent()[this.checked ? "addClass" : "removeClass"]("row-checked");
        });
    },

    importedListPaginationInput() {
        $('.pagination-input .pages-control i').on('click', function () {
            let paginationInput = $('.pagination-input input');
            if ($(this).hasClass('up')) {
                paginationInput.val(parseInt(paginationInput.val()) + 1);
            } else {
                paginationInput.val(parseInt(paginationInput.val()) - 1);
            }

            if (paginationInput.val() < 1) {
                paginationInput.val(1);
            }
        });
    },

    addColAction(){
        $('body').on('click', '.dublicate-col-action', function(){
            let col = $(this).closest('th').attr('data-column');
            let options = $('#options-holder').html();
            let colLetter = $(this).closest('th').attr('data-column-letter');
            let colNumber = $(this).closest('th').attr('data-column-number');
            let newCol;
            let latestColNumber = 0;
            $('.th-select[data-column-letter="'+colLetter+'"]').each(function(){
                if($(this).attr('data-column-number')>latestColNumber){
                    latestColNumber = $(this).attr('data-column-number');
                };
            });
            let newColNumber = 0;
            newColNumber = parseInt(latestColNumber) + 1;
            let lastColNumber = colLetter+'-'+latestColNumber;
            newCol = colLetter+'-'+newColNumber;

            $('[data-column="'+col+'"]').each(function(){
                let data;
                let clone;
                if ($(this).is('th.th-select')) {
                    data = '<th class="column th-select" data-column="'+newCol+'" data-column-letter="'+colLetter+'" data-column-number="'+newColNumber+'"><div class="imported-file-table--choose">\n' +
                        '\t\t\t\t\t\t\t\t\t<div class="letter">'+newCol+'</div>\n' +
                        '\t\t\t\t\t\t\t\t\t<div class="select-item sub-item">\n' +
                        '\t\t\t\t\t\t\t\t\t\t<select name="select_template" class="select-template" data-isset="col-'+newCol+'"\n' +
                        '\t\t\t\t\t\t\t\t\t\t        data-placeholder="Select template">\n' +
                            options +
                            // '\t\t\t\t\t\t\t\t\t\t\t<option></option>\n' +
                            // '\t\t\t\t\t\t\t\t\t\t\t<option value="1">Template 1</option>\n' +
                            // '\t\t\t\t\t\t\t\t\t\t\t<option value="2" disabled="disabled">Template 2 disabled</option>\n' +
                            // '\t\t\t\t\t\t\t\t\t\t\t<option value="3">Template 3</option>\n' +
                        '\t\t\t\t\t\t\t\t\t\t</select>\n' +
                        '\t\t\t\t\t\t\t\t\t</div>\n' +
                        '\t\t\t\t\t\t\t\t\t<div class="dropdown table-actions-dropdown table-actions-dropdown-vertical">\n' +
                        '\t\t\t\t\t\t\t\t\t\t<button class="btn actions-more dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>\n' +
                        '\t\t\t\t\t\t\t\t\t\t<ul class="dropdown-menu">\n' +
                        '\t\t\t\t\t\t\t\t\t\t\t<li><div class="dropdown-menu--title">Settings</div></li>\n' +
                        '\t\t\t\t\t\t\t\t\t\t\t<li><button class="dropdown-item dublicate-col-action" data-letter="'+newCol+'" type="button">Dublicate</button></li>\n' +
                        '\t\t\t\t\t\t\t\t\t\t\t<li><button class="dropdown-item delete-col-action" type="button">Delete</button></li>\n' +
                        '\t\t\t\t\t\t\t\t\t\t</ul>\n' +
                        '\t\t\t\t\t\t\t\t\t</div>\n' +
                        '\t\t\t\t\t\t\t\t</div>' +
                        '</th>'

                    // data = '<th class="column th-select" data-column="'+newCol+'" data-column-letter="'+colLetter+'" data-column-number="'+newColNumber+'"><div class="imported-file-table--choose">\n' +
                    //     '\t\t\t\t\t\t\t\t\t<div class="letter">'+newCol+'</div>\n' +
                    //     '\t\t\t\t\t\t\t\t\t<div class="select-item sub-item">\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t<select name="select_template" class="select-template" data-isset="col-'+newCol+'"\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t        data-placeholder="Select template">\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<option></option>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<option value="1">Template 1</option>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<option value="2" disabled="disabled">Template 2 disabled</option>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<option value="3">Template 3</option>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t</select>\n' +
                    //     '\t\t\t\t\t\t\t\t\t</div>\n' +
                    //     '\t\t\t\t\t\t\t\t\t<div class="dropdown table-actions-dropdown table-actions-dropdown-vertical">\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t<button class="btn actions-more dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t<ul class="dropdown-menu">\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<li><div class="dropdown-menu--title">Settings</div></li>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<li><button class="dropdown-item dublicate-col-action" data-letter="'+newCol+'" type="button">Dublicate</button></li>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t\t<li><button class="dropdown-item delete-col-action" type="button">Delete</button></li>\n' +
                    //     '\t\t\t\t\t\t\t\t\t\t</ul>\n' +
                    //     '\t\t\t\t\t\t\t\t\t</div>\n' +
                    //     '\t\t\t\t\t\t\t\t</div>' +
                    //     '</th>'
                    clone = data;
                    $(clone).insertAfter($(this).parent().find('th.th-select[data-column="'+lastColNumber+'"]'));
                    $('select.select-template').select2({});
                }
                if($(this).is('th.th-selected')){
                    clone = '<th class="column col-'+newCol+' th-selected" data-column="'+newCol+'"></th>';
                    $(clone).insertAfter($(this).parent().find('th.th-selected[data-column="'+lastColNumber+'"]'));
                }
                
                if ($(this).is('td')) {
                    let data = $(this).find('input').clone();
                    clone = '<td class="column" data-column="'+newCol+'"></td>';
                    $(clone).insertAfter($(this).parent().find('td[data-column="'+lastColNumber+'"]'));
                    $(this).parent().find('td[data-column="'+newCol+'"]').html(data);
                }
            });
        });
    },

    deleteColAction(){
        $('body').on('click', '.delete-col-action', function() {
            let col = $(this).closest('th').attr('data-column');
            let colLetter = $(this).closest('th').attr('data-column-letter');
            let colNumber = $(this).closest('th').attr('data-column-number');
            $('[data-column="'+col+'"]').each(function(){
                $(this).remove();
            });
            let latestColNumber = colNumber;
            $('.th-select[data-column-letter="'+colLetter+'"]').each(function(){
                if($(this).data('column-number')>latestColNumber){
                    latestColNumber = $(this).data('column-number');
                };
            });
            if(colNumber != latestColNumber){
                $('.th-select[data-column-letter="'+colLetter+'"]').each(function(){
                    let number = $(this).attr('data-column-number');
                    if(number>0 && number>colNumber) {
                        let newNumber = number - 1;
                        let odlVal = $(this).attr('data-column');
                        let newVal = colLetter+'-'+newNumber;
                        $('.th-select[data-column="'+odlVal+'"]').attr('data-column-number', newNumber);
                        if(newNumber == 0){
                            $('.th-select[data-column="'+odlVal+'"]').find('.letter').html(colLetter);
                        } else {
                            $('.th-select[data-column="'+odlVal+'"]').find('.letter').html(newVal);
                        }
                        $('th[data-column="'+odlVal+'"]').each(function(){
                            $(this).attr('data-column',newVal);
                        });
                        $('td[data-column="'+odlVal+'"]').each(function(){
                            $(this).attr('data-column',newVal);
                        });
                    }
                });
            }
        });
    },


}